module.exports = __webpack_public_path__ + "img/light_7.26a79c4e.png";